'use strict'

module.exports = caseSensitiveTransform

function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}



//////////////////
// WEBPACK FOOTER
// ./~/rehype-react/~/property-information/lib/util/case-sensitive-transform.js
// module id = 422
// module chunks = 35783957827783 241767136424496